$(document).ready(function(){

    let ajaxLockActive = false;
    let discountCodeWrapper = $('div#discount_code_wrapper');
    let form = $('div#discount_code_form_wrapper', discountCodeWrapper);
    let listGroup = $('div#discount_code_list_wrapper div.list-group', discountCodeWrapper);

    const ajaxPathSaveDiscountCode = '/action/discount/save-discount-code';
    const ajaxPathGetDiscountCodeForm = '/action/discount/get-discount-code-form';
    const ajaxPathDeactivateDiscount = '/action/discount/deactivate-discount';
    const ajaxPathActivateDiscount = '/action/discount/activate-discount';
    const ajaxPathGetListItems = '/action/discount/discount-code-list-items';

    validateForm();

    // Save new discount code
    $(discountCodeWrapper).on('click','div#save_discount_code',function() {
        saveDiscountCode();
    });

    // Activate or deactivate discount
    $(discountCodeWrapper).on('click','div#deactivate_discount',function() {
        if (!confirm('Vil du deaktivere denne rabattkoden?')) {
            return false;
        }

        changeStatus($('input[name="price_info_id"]', discountCodeWrapper).val(), ajaxPathDeactivateDiscount);
    });
    $(discountCodeWrapper).on('click','div#activate_discount',function() {
        changeStatus($('input[name="price_info_id"]', discountCodeWrapper).val(), ajaxPathActivateDiscount);
    });

    // Click on discount in the list of existing discounts
    $(discountCodeWrapper).on('click', 'div#discount_code_list_wrapper a.list-group-item',function () {
        let priceInfoId = $(this).attr('price_info_id') * 1;

        setActiveListItem('div#discount_code_list_wrapper .list-group-item', priceInfoId, 'price_info_id');
        getForm(priceInfoId);
        return false;
    });

    // Toggle deactivated discounts
    $(discountCodeWrapper).on('click','div#discount_code_list_wrapper input[name="display_deactivated"]',function() {
        refreshList();
    });

    /*
     * Display or hide filter options
     */
    $(discountCodeWrapper).on('click', 'span#filter_span_wrapper',function () {
        // Toggle the filters wrapper
        $('div#filter_options_wrapper').toggle();

        // Change class of the glyphicon (arrow right or down
        let arrow = $('span#filter_span_wrapper span.glyphicon');
        if ($(arrow).hasClass('glyphicon-chevron-right')) {
            // Switch to down arrow
            $(arrow).removeClass('glyphicon-chevron-right');
            $(arrow).addClass('glyphicon-chevron-down');
        } else {
            // Switch to down right
            $(arrow).removeClass('glyphicon-chevron-down');
            $(arrow).addClass('glyphicon-chevron-right');
        }
    });


    function saveDiscountCode() {
        removeSaveSuccessMessage();

        // Check that a save operation is not already in process
        if (ajaxLockActive) {
            return false;
        }

        let validator = $('form#discount_code_form').validate();
        if (!validator.form()) {
            return false;
        }

        let priceInfoId = 0;
        let priceInfoIdHiddenInput = $('div#discount_code_wrapper div#discount_code_save_button_wrapper input[name="price_info_id"]');
        if (priceInfoIdHiddenInput.length) {
            priceInfoId = priceInfoIdHiddenInput.val();
        }

        ajaxLockActive = true;

        //Post serialized form and save PriceLevel
        $.ajax({
            type: 'POST',
            url: ajaxPathSaveDiscountCode,
            data: $('form#discount_code_form', discountCodeWrapper).serialize(),
            dataType: 'json',
        }).success(function (data) {
            let successMessage = '';
            if (priceInfoId > 0) {
                successMessage = 'Trykk <a href="' + window.location.href + '"><b>her</b></a> for å opprette ny rabattkode';
            }
            getForm(priceInfoId, true, successMessage);
            refreshList();
        }).error(function (data) {
            let message = $.parseJSON(data.responseText).error_message;
            displayTailwindAlert('Feil!', message, '#alert_message', 'error', 'replace', true);
        }).always(function () {
            ajaxLockActive = false;
        });
    }


    /**
     * @param {int} priceInfoId
     * @param {boolean} includeSaveSuccessMessage
     * @param {string} successMessage
     * @param {string} successTitle
     */
    function getForm(priceInfoId, includeSaveSuccessMessage = false, successMessage = '', successTitle = 'Rabattkode lagret!') {
        $.ajax({
            type: 'GET',
            url: ajaxPathGetDiscountCodeForm,
            data: {
                price_info_id: priceInfoId
            },
            dataType: 'json',
        }).success(function (data) {
            $('div#discount_code_wrapper div#discount_code_form_wrapper').replaceWith(data.html);

            if (includeSaveSuccessMessage) {
                let displayMessage = 'Du kan finne den lagrede koden i lista til høyre.';
                if (successMessage != '') {
                    displayMessage = successMessage;
                }
                displayTailwindAlert(successTitle, displayMessage, '#alert_message', 'success', 'replace', true);
            }
        }).error(function (data) {
            let message = $.parseJSON(data.responseText).error_message;
            displayTailwindAlert('Feil!', message, '#alert_message', 'error', 'replace', true);
        });
    }

    /**
     *
     * @returns {boolean}
     */
    function refreshList() {
        let path = ajaxPathGetListItems;
        if ($('div#discount_code_wrapper input[name="display_deactivated"]').is(':checked')) {
            path = ajaxPathGetListItems + "?include_deactivated=1";
        }

        $.ajax({
            type: 'GET',
            url: path,
            dataType: 'json',
        }).success(function (data) {
            listGroup.html(data.html);
        }).error(function (data) {
            let message = $.parseJSON(data.responseText).error_message;
            displayTailwindAlert('Feil!', message, '#alert_message', 'error', 'replace', true);
        });
    }

    /**
     * @param {int} priceInfoId
     * @param {string} ajaxPath
     */
    function changeStatus(priceInfoId, ajaxPath) {

        // Check that a save operation is not already in process
        if (ajaxLockActive) {
            return false;
        }

        ajaxLockActive = true;

        //Post serialized form and save PriceLevel
        $.ajax({
            type: 'POST',
            url: ajaxPath,
            data: {
                price_info_id: priceInfoId,
                delete_fline_memcache: true
            },
            dataType: 'json',
        }).success(function () {
            let successTitle = ajaxPath == ajaxPathDeactivateDiscount ? 'Rabattkode deaktivert!' : 'Rabattkode aktivert!';
            let successMessage = ajaxPath == ajaxPathDeactivateDiscount ? 'Rabattkoden ble deaktivert.' : 'Rabattkoden ble aktivert.';

            getForm(priceInfoId, true, successMessage, successTitle);
            refreshList();
        }).error(function (data) {
            let message = $.parseJSON(data.responseText).error_message;
            displayTailwindAlert('Feil!', message, '#alert_message', 'error', 'replace', true);
        }).always(function () {
            ajaxLockActive = false;
        });
    }

    function removeSaveSuccessMessage() {
        let successMessageElement = $('div#discount_code_form_wrapper .alert');
        if (successMessageElement.length) {
            successMessageElement.remove();
        }
    }

    function validateForm() {
        $('form#discount_code_form').validate({
            rules: {
                discount_name: "required",
                discount_percent: {
                    required : true,
                    digits : true,
                    range: [0,100]
                }
            },
            messages: {
                discount_name: "Vennligst oppgi et navn på rabattkoden",
                discount_percent:  {
                    required: "Vennligst oppgi hvor mange % rabatt denne koden skal gi",
                    range: "Oppgi en prosent mellom 0 og 100",
                    digits: "Oppgi en prosent mellom 0 og 100",
                },
            },
            highlight: function ( element, errorClass, validClass ) {
                $( element ).parents( ".input-column" ).addClass( "has-error" ).removeClass( "has-success" );
            },
            unhighlight: function (element, errorClass, validClass) {
                $( element ).parents( ".input-column" ).addClass( "has-success" ).removeClass( "has-error" );
            },
            errorElement: 'em',
            errorClass: 'help-block',
            errorPlacement: function(error, element) {
                if(element.parent('.input-group').length) {
                    if (!(element.parent().parent().children('.error-container').length)) {
                        element.parent().after('<div class="col-sm-offset-3 col-sm-8 has-error error-container"></div>');
                    }
                    element.parent().parent().children('.error-container').append(error);

                } else {
                    error.insertAfter(element);
                }
            }
        });

    }

});
